import { Avatar } from '@mui/material';
import React, { useMemo } from 'react';
import { getManufacturer, getServiceKnowledge } from '../Helper/integrationKnowledge';
import { GenericIcon } from 'src/Common/Components/GenericIcon';

interface Props {
  serviceName: string;
  size?: number;
}

/**
 * The logo/icon tile for a system, shown on an integration card and in the
 * catalog. Renders the vendor's square icon mark when present, otherwise a
 * colored icon tile. The wide `logo` lockup is deliberately NOT used here — it
 * renders illegibly small in a square; it belongs on roomier surfaces.
 */
export const ServiceAvatar = ({ serviceName, size = 44 }: Props): React.JSX.Element => {
  const knowledge = useMemo(() => getServiceKnowledge(serviceName), [serviceName]);
  const manufacturer = useMemo(() => {
    if (knowledge?.manufacturerId !== undefined) {
      return getManufacturer(knowledge.manufacturerId);
    }
    return undefined;
  }, [knowledge?.manufacturerId]);

  const markSrc = knowledge?.icon ?? manufacturer?.icon;

  if (markSrc) {
    return (
      <Avatar
        src={markSrc}
        alt={serviceName}
        variant={'rounded'}
        sx={{
          width: size,
          height: size,
          bgcolor: 'background.default',
          border: '1px solid',
          borderColor: 'divider',
          p: 1,
          '& img': { objectFit: 'contain' },
        }}
      />
    );
  }

  return (
    <GenericIcon
      identifier={knowledge?.displayName ?? serviceName}
      colorSeed={manufacturer?.name ?? knowledge?.displayName ?? serviceName}
    />
  );
};
